import { Box } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";

export function DotAndLine({
  showTop = true,
  showBottom = true,
  dotSize = 6,
  lineWidth = "1px",
  topLineHeight = 20, // px
  bottomLineHeight = 36, //px
}) {
  const colors = useColors();

  const verticalGap = 2; // px

  return (
    <Box position="relative" height={66} width={dotSize} padding="0 4px">
      {/* Dot */}
      <Box
        sx={{
          position: "absolute",
          top: topLineHeight + verticalGap,
          left: "50%",
          transform: "translateX(-50%)",
          width: dotSize,
          height: dotSize,
          background: colors.timeline_stroke,
          borderRadius: "50%",
          zIndex: 1,
        }}
      />

      {showTop && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: lineWidth,
            height: topLineHeight,
            background: colors.timeline_stroke,
            borderRadius: 1,
          }}
        />
      )}

      {showBottom && (
        <Box
          sx={{
            position: "absolute",
            top: topLineHeight + verticalGap + dotSize + verticalGap,
            left: "50%",
            transform: "translateX(-50%)",
            width: lineWidth,
            height: bottomLineHeight,
            background: colors.timeline_stroke,
            borderRadius: 1,
          }}
        />
      )}
    </Box>
  );
}
